import { FeaturedImageFragment } from '@/fragments/FeaturedImage'
import { gql } from '@apollo/client'

export const variables = ({ databaseId }, ctx) => {
  return {
    databaseId,
    asPreview: ctx?.asPreview
  }
}

export const query = gql`
  ${FeaturedImageFragment}
  query GetMotechPageData($databaseId: ID!, $asPreview: Boolean = false) {
    page(id: $databaseId, idType: DATABASE_ID, asPreview: $asPreview) {
      title
      seo {
        metaDesc
        title
      }
      ...FeaturedImageFragment
      motechTestimonials {
        testimonials {
          quote
          name
          title
          headshot {
            node {
              sourceUrl
              altText
            }
          }
        }
      }
      motechLoopPhotos {
        images {
          image {
            node {
              sourceUrl
            }
          }
        }
      }
      motechCapabilities {
        cards {
          cardTitle
          cardContent
          cardIcon {
            node {
              sourceUrl
              altText
            }
          }
        }
      }
    }
  }
`
